import { render, staticRenderFns } from "./SpinnerProcessamento.vue?vue&type=template&id=337a2e10&scoped=true"
import script from "./SpinnerProcessamento.vue?vue&type=script&lang=js"
export * from "./SpinnerProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337a2e10",
  null
  
)

export default component.exports